<template>
  <el-form :model="form" :rules="rules" ref="ruleForm" label-width="160px">
    <el-form-item label="发票性质：" prop="openingType">
      <el-select
        v-model="form.openingType"
        @change="handleOpeningType"
        placeholder="请选择发票性质"
        class="ipt-width"
      >
        <el-option
          v-for="(item, key) in billMap"
          :key="key"
          :label="item"
          :value="key"
        >
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="发票类型：" prop="invoiceType">
      <el-select
        v-model="form.invoiceType"
        class="ipt-width"
        placeholder="请选择发票发票类型"
      >
        <el-option
          v-for="(item, key) in invoiceTypeMapUse"
          :key="key"
          :label="item"
          :value="key"
        >
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="发票寄送地址：" prop="userAddressId">
      <el-select
        v-model="form.userAddressId"
        placeholder="请选择发票寄送地址"
        class="address"
      >
        <el-option
          v-for="item in address"
          :key="item.id"
          :label="item.address"
          :value="item.id"
        >
        </el-option>
      </el-select>
      <span class="editAddress" @click="addOrUpdateAddress">新增/修改地址</span>
    </el-form-item>
    <el-form-item label="发票抬头(企业名称)：" prop="invoiceTitle">
      <el-input
        class="ipt-width"
        v-model.trim="form.invoiceTitle"
        placeholder="请输入发票抬头(企业名称)"
      ></el-input>
    </el-form-item>
    <el-form-item label="纳税人识别号：" prop="taxCertificate">
      <el-input
        v-model.trim="form.taxCertificate"
        placeholder="请输入纳税人识别号"
      ></el-input>
    </el-form-item>
    <el-form-item label="开户银行：" prop="accountBankName">
      <el-input
        v-model.trim="form.accountBankName"
        placeholder="请输入开户银行"
      ></el-input>
    </el-form-item>
    <el-form-item label="开户银行账号：" prop="accountBankNum">
      <el-input
        v-model.trim="form.accountBankNum"
        placeholder="请输入开户银行账号"
      ></el-input>
    </el-form-item>
    <el-form-item label="企业地址：" prop="registerCompany">
      <el-input
        v-model.trim="form.registerCompany"
        placeholder="请输入企业地址"
      ></el-input>
    </el-form-item>
    <el-form-item label="企业电话：" prop="registerPhone">
      <el-input
        v-model.trim="form.registerPhone"
        placeholder="请输入企业电话"
      ></el-input>
    </el-form-item>
    <el-form-item label="发票申请说明：" prop="invoiceApplyExplain">
      <el-input
        type="textarea"
        v-model.trim="form.invoiceApplyExplain"
        placeholder="请输入发票申请说明"
      ></el-input>
    </el-form-item>
    <el-form-item label="发票票面备注：" prop="invoiceRemark">
      <el-input
        type="textarea"
        v-model.trim="form.invoiceRemark"
        placeholder="请输入发票票面备注"
      ></el-input>
    </el-form-item>
  </el-form>
</template>
<script>
import {
  addressList,
  getReservationInvoice,
  getReservationInvoiceList,
  reservationInvoice,
} from "@/api/userCenter";
import { deepClone } from "@/utils/index";
import { mapGetters } from "vuex";
export default {
  data() {
    const baseRules = {
      openingType: [
        { required: true, message: "请选择发票性质", trigger: "change" },
      ],
      invoiceType: [
        { required: true, message: "请选择发票类型", trigger: "change" },
      ],
      invoiceTitle: [
        { required: true, message: "请输入发票抬头", trigger: "blur" },
      ],
      taxCertificate: [
        { required: true, message: "请输入纳税人识别号", trigger: "blur" },
        { min: 18, max: 18, message: "长度必须为18个字符", trigger: "blur" },
      ],
    };
    const allRules = {
      userAddressId: [
        { required: true, message: "请选择发票寄地址", trigger: "change" },
      ],
      accountBankName: [
        { required: true, message: "请输入开户银行", trigger: "blur" },
      ],
      accountBankNum: [
        { required: true, message: "请输入开户银行账号", trigger: "blur" },
      ],
      registerCompany: [
        { required: true, message: "请输入企业地址", trigger: "blur" },
      ],
      registerPhone: [
        { required: true, message: "请输入企业电话", trigger: "blur" },
      ],
    };
    return {
      form: {
        openingType: "1",
        invoiceType: "p",
        invoiceTitle: "",
        taxCertificate: "",
        accountBankName: "",
        accountBankNum: "",
        registerCompany: "",
        registerPhone: "",
        invoiceApplyExplain: "",
        invoiceRemark: "",
      },
      rules: baseRules,
      address: [],
      billMap: {},
      invoiceTypeMap: {},
      invoiceTypeMapUse: {},
      page: {
        pageIndex: 1,
        pageSize: 5,
      },
      totalItem: 0,
      allRules,
      baseRules,
      enterpriseOptions: [],
    };
  },
  computed: {
    ...mapGetters(["userBaseInfo"]),
  },
  async created() {
    await this.getDict();
    await this.getAddressList();
    await this.getReservationInvoiceList();
    if (this.totalItem) {
      await this.getReservationInvoice();
    }
    this.handleOpeningType(this.form.openingType);
  },
  methods: {
    // 数据字典 发票性质和发票类型
    async getDict() {
      const data = await this.$store.dispatch("getDictData", "opening_type");
      const map = {};
      data.forEach((item) => {
        map[item.dictValue] = item.dictLabel;
      });
      this.billMap = map;
      const res = await this.$store.dispatch("getDictData", "invoice_type");
      const dMap = {};
      res.forEach((item) => {
        dMap[item.dictValue] = item.dictLabel;
      });
      this.invoiceTypeMap = dMap;
    },
    async getAddressList() {
      const data = await this.$axios.get(addressList);
      this.address = data.map((item) => {
        const link = `${item.linkMan}(${item.linkPhone}) `;
        const addressDetail = `${item.addressProvince}${item.addressCity}${item.addressDistrict}${item.addressDetailed}`;
        return {
          address: `${link}${addressDetail}`,
          id: item.userAddressId,
        };
      });
    },
    addOrUpdateAddress() {
      this.$router.push({ name: "addressManage" });
    },

    // 提交
    async submitForm() {
      await this.$axios.post(reservationInvoice, {
        ...this.form,
      });
      this.$emit("saveSuccess");
    },

    // 获取发票预留信息
    async getReservationInvoice() {
      const data = await this.$axios.get(getReservationInvoice);
      this.form = data;
    },

    // 获取预留信息列表
    async getReservationInvoiceList() {
      const { totalItem } = await this.$axios.post(getReservationInvoiceList, {
        ...this.page,
        userId: this.userBaseInfo.userId,
      });
      this.totalItem = totalItem;
    },

    // 选择发票性质
    handleOpeningType(value) {
      // 选纸质，仅展示纸质发票类型；选电子，仅展示电子发票类型。
      const invoiceTypeMap = deepClone(this.invoiceTypeMap);
      const res = Object.entries(invoiceTypeMap).filter((item) => {
        // eslint-disable-next-line no-unused-vars
        const [key, val] = item;
        if (value === "0") {
          return val.includes("纸质");
        }
        if (value === "1") {
          return val.includes("电子");
        }
      });
      const objRes = Object.fromEntries(res);
      this.invoiceTypeMapUse = objRes;

      this.rules = {
        ...(value === "0" ? this.allRules : {}),
        ...this.baseRules,
      };
      // 发票性质和发票类型map 0: 纸质, 1: 电子
      const map = {
        0: "s",
        1: "p",
      };
      this.form.invoiceType = map[value];
    },
  },
};
</script>
<style lang="scss" scoped>
.address {
  width: 400px;
}
.editAddress {
  margin-left: 10px;
  cursor: pointer;
  color: #3073f4;
}
.ipt-width {
  width: 400px;
}
</style>
